import Styles from "../styles";
import { FormFull } from "form-full";
import { hooks, masks, validations } from "../../../utils";

import { fonts, SVG } from "../../../config";
import { Grid } from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import ptBr from "../../../config/texts/pt-br";
import { CustomText, Input, InputTags } from "../../../components/index";
import { api } from "../../../services";
import React from "react";

interface Visitor{
    id: string,
    placeId: any,
    name: string,
    cpf: string,
    email: string,
    startDate: any,
    endDate: any
}

function ModalVisitorRevokeAccess({ item }) {
  const { call } = hooks.useRequest();
  const texts = ptBr.login;
  const [visitors, setVisitors] = React.useState<{
    label: string,
    value: string
  }[]>();
  
  const onSubmit2 = async (data: any) => {
    if(data.guests.length>0){
      var counter = 0;
      for (let index = 0; index < data.guests.length; index++) {
        const element = data.guests[index];
        if(element.label==="Todos"){
          counter++;
          continue;
        }
        let dataobj = JSON.parse(element.value);
        call(null, api.patchReservationRevoke({reservationId:dataobj.id}), (response) => {
          if (response.ok) {
            counter++;
            if(counter==data.guests.length){
              customModal.close();
              customModal.setInfos(
                "Revogar Acesso a Visitante",
                [
                  "Acessos revogados com sucesso!"
                ],
                {
                  label: "Ok, Entendi",
                  onClick: () => {
                    customModal.close();
                  },
                },
                null,
                null,
                false,
                true,
                <Styles.VisitorIcon $customColor />
              );
            }
          }
        });
      }
    }
  };

  React.useEffect(() => {
    call(null, api.listVisitor({placeId:item.place.id}), (response) => {
      if (response.ok) {
        const teamsOptions:any[] = [];
        for (let index = 0; index < response.data.content.length; index++) {
          const element = response.data.content[index];
          teamsOptions.push({
            label: element.name,
            value: JSON.stringify(element)
          });
        }
        setVisitors(teamsOptions);
      }
    });
  }, []);
  


  
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(250px, 26vw, 500px)",
          paddingInline: "25px",
          marginBottom: "20px",
        }}
      >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          gap: "12px",
          marginBottom: "25px",
          width: "100%",
        }}
      >
          Revogar Visitantes
      </div>
      {
        <FormFull onSubmit={onSubmit2}>
          <CustomText
            style={{ marginBottom: "20px" }}
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2">
          Selecione os visitantes cadastrados na lista abaixo para revogar o acesso concedido:
          </CustomText>
          <Grid alignItems="flex-end" container spacing={3}>
            <Grid item xs={12} md={6} lg={12}>
              <InputTags
                white
                name="guests"
                label="LISTA DE VISITANTES CADASTRADOS ANTERIORMENTE"
                options={visitors ? visitors : []} 
                defaultValue={[]}/>
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "25px",
              width: "100%",
            }}
          >
            <Styles.CancelButton
              fullWidth={false}
              onClick={() => customModal.close()}
            >
              Cancelar
            </Styles.CancelButton>
            <Styles.ConfirmButton fullWidth={false} action="submit">
              Confirmar
            </Styles.ConfirmButton>
          </div>
        </FormFull>
        }
      </div>
    </>
  );
}

export default ModalVisitorRevokeAccess;
